import { gql } from "@apollo/client";
import {
    ROUTE_STATISTICS_FIELDS,
    RouteStatistics,
    BagType
} from "../types/ConsolidationTypes";

export const GET_CONSOLIDATION_PREVIEW_STATISTICS = gql`
    query GetConsolidationPreviewStatistics($input: ConsolidationOrderQueryTypeInput!) {
        getConsolidationPreviewStatistics(input: $input) {
            totalParcelCount
            estimatedBagCount
            routeStats {
                ...RouteStatisticsFields
            }
            canCreateConsolidation
            message
        }
    }
    ${ROUTE_STATISTICS_FIELDS}
`;

export interface GetConsolidationPreviewVariables {
    input: {
        warehouseId: string;
        destinationHubId?: string;
        destinationWhsId?: string;
        expectedDeliveryTimeStart?: string;
        expectedDeliveryTimeEnd?: string;
        bagType?: BagType;
        carrierCode?: number;
    };
}

export interface GetConsolidationPreviewResponse {
    getConsolidationPreviewStatistics: {
        totalParcelCount: number;
        estimatedBagCount: number;
        routeStats: RouteStatistics[];
        canCreateConsolidation: boolean;
        message?: string;
    };
} 